module.exports = __webpack_public_path__ + "media/images/front/not-logged-in-lp-renew/logo_jua-69104cb88e062d3cecbc1e2476e64124.svg";